import { Component, OnInit, ChangeDetectorRef, Input, ChangeDetectionStrategy } from '@angular/core';
import { UserService } from '../_services/user.service';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { config } from '../_models/apiConfig';
import { ScrollService } from '../_services/scroll.service';

@Component({
  selector: 'follow-widget',
  templateUrl: './follow-widget.component.html',
  styleUrls: ['./follow-widget.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FollowWidgetComponent implements OnInit {
  @Input() companyBannerImage?: any
  @Input() visible;
  @Input() bannerLinks?: any
  array: any[] = [];
  users = [];
  following: any[] = [];
  requests: any[] = [];
  date = Date.now();
  user: any;
  brandName: string;
  uniqueName: string;
  userNotFollow: any[] = [];
  userId = localStorage.getItem("currentUserId");
  private subscription: Subscription = new Subscription();
  constructor(private cd: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private scrollservice: ScrollService,
    private http: Http) {


    this.subscription.add(this.userService.getUser().subscribe(user => {
      this.user = user;
      try {
        this.following = this.user.following ? Object.values(this.user.following.user ? this.user.following.user : []) : [];
        this.requests = Object.values(this.user.requests ? this.user.requests : []);
        this.following.forEach(user => {
          this.userNotFollow.push(user.username);
        });
        this.requests.forEach(request => {
          this.userNotFollow.push(request.username);
        });
        this.randomFollow();
        this.cd.markForCheck();
      } catch (e) {
      }
    }))




  }

  isLoggedIn() {
    if (!this.userId)
      this.router.navigate(['/auth'])
  }

  ngOnInit() {


  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getUsers(data: any) {
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return this.subscription = this.http.post(config.live + `entity/userFollowSuggestions`, { followers: data, take: 3 }, { headers: headers })
      .map(res => res.json()).map(res => res.map(entity => {
        JSON.parse(entity);
        this.array.push(JSON.parse(entity));
        this.userNotFollow.push(JSON.parse(entity).uniqueName);
        this.cd.markForCheck();
      })).subscribe();
  }

  randomFollow() {

    if (this.user) {
      this.userNotFollow.push(this.user.username);
      this.getUsers(this.userNotFollow);
    }
    else {
      return this.randomFollow();
    }

  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/follow-widget/follow-widget.component.ts